import React from "react";
import AvatarComponent from "../../../components/tables/AvatarComponent";
import FullName from "../../../components/tables/FullName";
import { Typography, Badge, Tooltip, Button, Dropdown } from "antd";
import {
  ScheduleOutlined,
  EditOutlined,
  PlusOutlined,
  DeleteOutlined,
  DownOutlined,
  CheckCircleOutlined,
} from "@ant-design/icons";
import Phone from "../../../components/tables/Phone";
import moment from "moment";
import ManagedGapsReasons from "../../../components/tables/ManagedGapsReasons";
const { Text } = Typography;

const handleMenuClick = (
  e,
  record,
  onlaunchApprovalModal,
  onlaunchPatientApprovalModal
) => {
  switch (e.key) {
    case "1":
      onlaunchApprovalModal(record);
      break;
    case "2":
      onlaunchPatientApprovalModal(record);
      break;

    default:
      break;
  }
};

const getgapsColumns = (
  activeGap,
  intl,
  location,
  onlaunchPatientScheduler,
  onlaunchApprovalModal,
  onlaunchPatientApprovalModal,
  onlaunchEditCommentModal,
  onDeleteGapComment,
  hasEditorPermission
) => {
  let tableItems = [];
  const branchPath = location.pathname.substring(
    0,
    location.pathname.lastIndexOf("/")
  );
  switch (activeGap) {
    case "lack_of_extraction_of_hours":
      tableItems = [
        {
          title: "avatar_url",
          render: (row) => {
            return row.record && row.record.patient_avatar_url ? (
              <AvatarComponent
                record={{ first_name: row.record.patient_first_name }}
                text={row.record.patient_avatar_url}
              />
            ) : null;
          },
          width: "60px",
        },
        {
          title: "patient_name",
          render: (row) => {
            const name = {
              first_name: row.record.patient_first_name,
              surename: row.record.patient_surename,
            };
            return row.record && row.record.order ? (
              <FullName
                record={name}
                customLocation={`${branchPath}/patients/${row.record.patient_id}`}
              />
            ) : null;
          },
          sortIndex: "patient_surename",
          sorter: true,
          width: "200px",
        },
        {
          title: "client_name",
          render: (row) => {
            return row.record && row.record.order && row.record.order.client ? (
              <Text>{row.record.order.client.name}</Text>
            ) : null;
          },
          sortIndex: "client_name",
          sorter: true,
          responsive: ["lg"],
        },
        {
          title: "max_hours",
          responsive: ["xl"],
          sortIndex: "max_minutes",
          sorter: true,
          render: (row) => {
            return (
              <Text>
                {Math.round((row.record.max_minutes / 60) * 100) / 100}
              </Text>
            );
          },
        },
        {
          title: "scheduled_hours",
          responsive: ["xl"],
          sortIndex: "gaps_scheduled_minutes",
          sorter: true,
          render: (row) => {
            return (
              <Text>
                {Math.round((row.record.gaps_scheduled_minutes / 60) * 100) /
                  100}
              </Text>
            );
          },
        },
        {
          title: "lack_of_hours",
          responsive: ["md"],
          sortIndex: "scheduled_minutes_diff",
          sorter: true,
          render: (row) => {
            return (
              <Badge
                count={
                  Math.round((row.record.scheduled_minutes_diff / 60) * 100) /
                  100
                }
                style={{ backgroundColor: "#faad14", direction: "ltr" }}
                overflowCount={99999}
              />
            );
          },
        },
        {
          title: "order_gap_reason_managed_reason_name",
          sortIndex: "order_gap_reason_managed_reason_name",
          width: "180px",
          sorter: true,
          responsive: ["lg"],
        },
        {
          title: "order_gap_reason_comment",
          sortIndex: "order_gap_reason_comment",
          responsive: ["xl"],
          render: (row) => {
            return <Text>{row.record.order_gap_reason_comment}</Text>;
          },
          sorter: true,
        },
        {
          title: "actions",
          responsive: ["md"],
          width: "100px",
          render: ({ record }) => (
            <div style={{ display: "flex" }}>
              {hasEditorPermission && (
                <>
                  {record.order_gap_reason_comment ||
                  record.order_gap_reason_managed_reason_name ? (
                    <Tooltip
                      title={intl.formatMessage({
                        id: "app.gaps.edit_order_gap_reason_comment",
                      })}
                    >
                      <Button
                        type="text"
                        icon={<EditOutlined />}
                        onClick={() => onlaunchEditCommentModal(record, "edit")}
                      />
                    </Tooltip>
                  ) : (
                    <Tooltip
                      title={intl.formatMessage({
                        id: "app.gaps.new_order_gap_reason_comment",
                      })}
                    >
                      <Button
                        type="text"
                        icon={<PlusOutlined />}
                        onClick={() => onlaunchEditCommentModal(record, "new")}
                      />
                    </Tooltip>
                  )}
                  {record.order_gap_reason_comment && (
                    <Tooltip
                      title={intl.formatMessage({
                        id: "app.gaps.delete_order_gap_reason_comment",
                      })}
                    >
                      <Button
                        type="text"
                        icon={<DeleteOutlined />}
                        onClick={() => onDeleteGapComment(record)}
                      />
                    </Tooltip>
                  )}
                </>
              )}

              <Tooltip
                title={intl.formatMessage({
                  id: "app.gaps.fix_scheduling_gap",
                })}
              >
                <Button
                  type="text"
                  icon={<ScheduleOutlined />}
                  onClick={() => onlaunchPatientScheduler(record)}
                />
              </Tooltip>
            </div>
          ),
        },
      ];
      break;
    case "providing_overtime":
      tableItems = [
        {
          title: "avatar_url",
          render: (row) => {
            return row.record && row.record.patient_avatar_url ? (
              <AvatarComponent
                record={{ first_name: row.record.patient_first_name }}
                text={row.record.patient_avatar_url}
              />
            ) : null;
          },
          width: "60px",
        },
        {
          title: "patient_name",
          render: (row) => {
            const name = {
              first_name: row.record.patient_first_name,
              surename: row.record.patient_surename,
            };
            return row.record && row.record.order ? (
              <FullName
                record={name}
                customLocation={`${branchPath}/patients/${row.record.patient_id}`}
              />
            ) : null;
          },
          sortIndex: "patient_surename",
          sorter: true,
          width: "200px",
        },
        {
          title: "client_name",
          render: (row) => {
            return row.record && row.record.order && row.record.order.client ? (
              <Text>{row.record.order.client.name}</Text>
            ) : null;
          },
          sortIndex: "client_name",
          sorter: true,
          responsive: ["lg"],
        },
        {
          title: "max_hours",
          responsive: ["xl"],
          sortIndex: "max_minutes",
          sorter: true,
          render: (row) => {
            return (
              <Text>
                {Math.round((row.record.max_minutes / 60) * 100) / 100}
              </Text>
            );
          },
        },
        {
          title: "scheduled_hours",
          responsive: ["xl"],
          sortIndex: "gaps_scheduled_minutes",
          sorter: true,
          render: (row) => {
            return (
              <Text>
                {Math.round((row.record.gaps_scheduled_minutes / 60) * 100) /
                  100}
              </Text>
            );
          },
        },
        {
          title: "over_hours",
          responsive: ["md"],
          sortIndex: "scheduled_minutes_diff",
          sorter: true,
          render: (row) => {
            return (
              <Badge
                count={
                  Math.round((row.record.scheduled_minutes_diff / 60) * 100) /
                  100
                }
                style={{ backgroundColor: "#f5222d" }}
                overflowCount={99999}
              />
            );
          },
        },
        {
          title: "actions",
          responsive: ["md"],
          width: "100px",
          render: ({ record }) => (
            <div style={{ display: "flex" }}>
              <Tooltip
                title={intl.formatMessage({
                  id: "app.gaps.fix_scheduling_gap",
                })}
              >
                <Button
                  type="text"
                  icon={<ScheduleOutlined />}
                  onClick={() => onlaunchPatientScheduler(record)}
                />
              </Tooltip>
            </div>
          ),
        },
      ];
      break;

    case "unapproved_minutes":
      tableItems = [
        {
          title: "employee_name",
          render: (row) => {
            const name = {
              first_name: row.record.employee_first_name || "",
              surename: row.record.employee_surename || "",
            };
            return row.record && row.record.order ? (
              <FullName
                record={name}
                customLocation={`${branchPath}/employees/${row.record.employee_id}`}
                extraDetail={
                  row.record.employee_local_id_number &&
                  ` (${row.record.employee_local_id_number})`
                }
              />
            ) : null;
          },
          sortIndex: "employee_surename",
          sorter: true,
          // width: "200px",
        },
        {
          title: "employee_phone",
          render: (row) => {
            return <Phone text={row.record.employee_phone} />;
          },
          width: "140px",
          ellipsis: true,
        },
        {
          title: "patient_name",
          render: (row) => {
            const name = {
              first_name: row.record.patient_first_name,
              surename: row.record.patient_surename,
            };
            return row.record && row.record.order ? (
              <Tooltip
                placement="top"
                title={row.record.patient_local_id_number}
              >
                <div>
                  <FullName
                    record={name}
                    customLocation={`${branchPath}/patients/${row.record.patient_id}`}
                  />
                </div>
              </Tooltip>
            ) : null;
          },
          sortIndex: "patient_surename",
          sorter: true,
          width: "160px",
        },

        {
          title: "employee_hours",
          responsive: ["xl"],
          render: (row) => {
            return (
              <Text>
                {Math.round(
                  (row.record.employee_scheduled_minutes / 60) * 100
                ) / 100}
              </Text>
            );
          },
        },
        {
          title: "client_name",
          render: (row) => {
            return row.record && row.record.order && row.record.order.client ? (
              <Text>{row.record.order.client.name}</Text>
            ) : null;
          },
          sortIndex: "client_name",
          sorter: true,
          responsive: ["lg"],
        },
        {
          title: "approved_hours",
          responsive: ["xl"],
          render: (row) => {
            return (
              <Text>
                {Math.round(
                  ((row.record.employee_scheduled_minutes +
                    row.record.approved_minutes_diff) /
                    60) *
                    100
                ) / 100}
              </Text>
            );
          },
        },
        {
          title: "approved_minutes_diff",
          responsive: ["md"],
          sortIndex: "approved_minutes_diff",
          sorter: true,
          render: (row) => {
            return (
              <Badge
                count={
                  Math.round((row.record.approved_minutes_diff / -60) * 100) /
                  100
                }
                style={{ backgroundColor: "#f5222d" }}
                overflowCount={99999}
              />
            );
          },
        },
        {
          title: "actions",
          responsive: ["md"],
          width: "140px",
          render: ({ record }) => (
            <div style={{ display: "flex" }}>
              <Dropdown
                trigger={["click"]}
                menu={{
                  items: [
                    {
                      label: intl.formatMessage({
                        id: "app.gaps.approveScheduling_employee_side",
                      }),
                      key: "1",
                      icon: <ScheduleOutlined />,
                    },

                    {
                      label: intl.formatMessage({
                        id: "app.gaps.approveScheduling_patient_side",
                      }),
                      key: "2",
                      icon: <ScheduleOutlined />,
                    },
                  ],
                  onClick: (e) =>
                    handleMenuClick(
                      e,
                      record,
                      onlaunchApprovalModal,
                      onlaunchPatientApprovalModal
                    ),
                }}
              >
                <Button type="link">
                  {intl.formatMessage({
                    id: "app.orders.options",
                  })}
                  <DownOutlined />
                </Button>
              </Dropdown>
            </div>
          ),
        },
      ];
      break;

    case "ok2go":
      tableItems = [
        {
          title: "avatar_url",
          render: (row) => {
            return row.record && row.record.patient_avatar_url ? (
              <AvatarComponent
                record={{ first_name: row.record.patient_first_name }}
                text={row.record.patient_avatar_url}
              />
            ) : null;
          },
          width: "60px",
        },
        {
          title: "patient_name",
          render: (row) => {
            const name = {
              first_name: row.record.patient_first_name,
              surename: row.record.patient_surename,
            };
            return (
              <FullName
                record={name}
                customLocation={`${branchPath}/patients/${row.record.patient_id}`}
              />
            );
          },
          sortIndex: "patient_surename",
          sorter: true,
          width: "200px",
        },
        {
          title: "employee_name",
          sortIndex: "employee_surename",
          sorter: true,
          render: (row) => {
            const name = {
              first_name: row.record.employee_first_name || "",
              surename: row.record.employee_surename || "",
            };
            return (
              <FullName
                record={name}
                customLocation={`${branchPath}/employees/${row.record.employee_id}`}
              />
            );
          },
        },
        {
          title: "client_name",
          render: (row) => {
            return row.record && row.record.client_name ? (
              <Text>{row.record.client_name}</Text>
            ) : null;
          },
          sortIndex: "client_name",
          sorter: true,
          responsive: ["lg"],
        },
        {
          title: "date",
          render: (row) => {
            return row.record && row.record.date ? (
              <Text>{moment(row.record.date).format("DD/MM/YYYY")}</Text>
            ) : null;
          },
          sortIndex: "date",
          sorter: true,
          responsive: ["lg"],
        },
        {
          title: "missing_start",
          render: (row) => {
            return (
              !row.record?.ok2go_info?.date && (
                <div
                  style={{
                    width: "100%",
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                  }}
                >
                  <CheckCircleOutlined style={{ color: "#f5222d" }} />
                </div>
              )
            );
          },
          width: "120px",
          responsive: ["lg"],
        },
        {
          title: "missing_end",
          render: (row) => {
            return (
              row.record.ok2go_info.date && (
                <div
                  style={{
                    width: "100%",
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                  }}
                >
                  <CheckCircleOutlined style={{ color: "#f5222d" }} />
                </div>
              )
            );
          },
          width: "120px",
          responsive: ["lg"],
        },
        {
          title: "actions",
          responsive: ["md"],
          width: "100px",
          render: ({ record }) => (
            <div style={{ display: "flex" }}>
              <Tooltip
                title={intl.formatMessage({
                  id: "app.gaps.fix_scheduling_gap",
                })}
              >
                <Button
                  type="text"
                  icon={<ScheduleOutlined />}
                  onClick={() => onlaunchApprovalModal(record)}
                />
              </Tooltip>
            </div>
          ),
        },
      ];
      break;

    default:
      tableItems = [];
      break;
  }
  return tableItems;
};

export { getgapsColumns };
